module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _c('ForecastTable', [_c('template', {
    slot: "head-row-0"
  }, [_c('th', {
    staticClass: "items-included-text",
    attrs: {
      "colspan": "5"
    }
  }, [_c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.items.length))]), _vm._v("Items included in the forecast\n            ")])]), _vm._v(" "), _c('template', {
    slot: "head-row-2"
  }, [_c('th'), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Total QTY")]), _vm._v(" "), _c('th', [_vm._v("Markets with prices")]), _vm._v(" "), _c('th')]), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('tbody', _vm._l((_vm.items), function(item, index) {
    return _c('tr', {
      key: item.id,
      class: {
        isDisabled: _vm.isItemDisabled(item)
      }
    }, [_c('td', {
      style: (item.color != null && item.color !== '' ? 'border-left: 15px solid ' + item.color : '')
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('ItemImage', {
      staticClass: "item-image",
      attrs: {
        "item": item
      }
    })], 1), _vm._v(" "), _c('td', [_c('ItemDescription', {
      attrs: {
        "item": item,
        "forecast": _vm.forecast
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getQuantities(item)))]), _vm._v(" "), _c('td', [_c('AllPricesInfo', {
      attrs: {
        "item": item,
        "forecast-windows": _vm.forecastWindows
      }
    })], 1), _vm._v(" "), _c('td', [_c('ItemQuantitiesButton', {
      attrs: {
        "item": item,
        "forecast": _vm.forecast
      }
    })], 1)])
  }))])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb639794","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/ItemList.vue
// module id = 3364
// module chunks = 0